<template>
  <section>

    <el-form :inline="true" size="small" :model="model" :rules="addFormRules" ref="addForm">
      <el-form-item label="名称" prop="name">
        <el-input placeholder="名称" v-model="model.name" :disabled="!isCanEditTableName"></el-input>
      </el-form-item>
      <el-form-item label="表名称" prop="tableName">
        <el-input placeholder="表名" v-model="model.tableName" :disabled="!isCanEditTableName"></el-input>
      </el-form-item>
    </el-form>

    <!--工具条-->
    <el-col :span="24">
      <el-button size="mini" icon="el-icon-circle-plus" v-on:click="addColumn">新增</el-button>
      <el-button size="mini" icon="el-icon-s-unfold" v-on:click="insertColumn">插入</el-button>
      <el-button size="mini" icon="el-icon-remove" v-on:click="removeColumn">删除</el-button>
      <el-button size="mini" icon="el-icon-top" v-on:click="moveUpColumn">上移</el-button>
      <el-button size="mini" icon="el-icon-bottom" v-on:click="moveDownColumn">下移</el-button>
    </el-col>
    <!--列表-->
    <el-table :data="model.columns" highlight-current-row v-loading="listLoading" style="width: 100%;" :height="bodyHeight-260" @current-change="handleCurrentChange">
      <el-table-column type="index" width="60">
      </el-table-column>
      <el-table-column prop="displayName" label="显示名" min-width="200">
        <editable-cell :show-input="row.editMode" slot-scope="{row}" v-model="row.displayName">
          <div slot="content">{{row.displayName}}</div>
        </editable-cell>
      </el-table-column>
      <el-table-column prop="columnName" label="列名" min-width="200">
        <editable-cell :show-input="row.editMode" slot-scope="{row}" v-model="row.columnName">
          <div slot="content">{{row.columnName}}</div>
        </editable-cell>
      </el-table-column>
      <el-table-column prop="dataType" label="数据类型" min-width="80">
        <editable-cell :show-input="row.editMode" slot-scope="{row}" v-model="row.dataType"                       
         editable-component="el-select"
         close-event="change">
          <div slot="content">{{row.dataType}}</div>
          <template slot="edit-component-slot">
            <el-option value="varchar" label="字符串"></el-option>
            <el-option value="bigint" label="整型"></el-option>
            <el-option value="decimal" label="数值"></el-option>
            <el-option value="bit" label="布尔"></el-option>
            <el-option value="datetime" label="日期时间"></el-option>
          </template>
        </editable-cell>
      </el-table-column>
      <el-table-column prop="length" label="长度" min-width="80">
        <editable-cell :show-input="row.editMode" editable-type="number" slot-scope="{row}" v-model="row.length">
          <div slot="content">{{row.length}}</div>
        </editable-cell>
      </el-table-column>
      <el-table-column prop="isNull" label="是否可为空" min-width="180">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isNull"
                     active-color="#13ce66"
                     inactive-color="#ff4949">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="defaultValue" label="默认值" min-width="100">
        <editable-cell :show-input="row.editMode" slot-scope="{row}" v-model="row.defaultValue">
          <div slot="content">{{row.defaultValue}}</div>
        </editable-cell>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar"  style="padding-bottom: 8px;" align="right">
      <el-button type="primary" icon="el-icon-circle-check" :loading="addLoading" v-on:click="saveModel">保存</el-button>
      <el-button icon="el-icon-circle-close" v-on:click="$router.go(-1)">取消</el-button>
    </el-col>
  </section>
</template>
<style>
  i.Success {
    color: #67C23A
  }
  i.Info {
    color: #909399
  }
</style>

<script>
import EditableCell from "./EditableCell.vue"

export default {
  name: 'modeleditor',
  components: {
    EditableCell
  },
  props: ['bodyHeight'],
  data() {
    return {
      model: {
        taskId: 0,
        name: "",
        tableName: "",
        columns: []
      },
      currentRow: null,
      listLoading: false,
      addLoading: false,
      isCanEditTableName: true,
      addFormRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        tableName: [
          { required: true, message: '请输入表名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    getModel: function () {
      let taskId = this.$route.params.taskId;
      this.$ajax({
        url: 'api/DataCollect/GetModel?taskId=' + taskId,
        success: (d) => {
          if (d) {
            this.model = d
            this.isCanEditTableName = false
          }
          else {
            this.isCanEditTableName = true
            this.model.taskId = taskId

          }
        }
      })
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    addColumn: function () {
      this.model.columns.push({ displayName: "字段名", columnName: "Colnum", dataType: "", length: 0, isNull: true, defaultValue:""});
    },
    insertColumn: function () {
      if (this.currentRow) {
        let index = this.model.columns.indexOf(this.currentRow)
        if (index >= 0)
          this.model.columns.splice(index, 0, { displayName: "字段名", columnName: "Colnum", dataType: "", length: 0, isNull: true, defaultValue: "" })
      }
      else if (this.model.columns.length == 0) {
        this.model.columns.push({ displayName: "字段名", columnName: "Colnum", dataType: "", length: 0, isNull: true, defaultValue: "" });
      }

    },
    removeColumn: function () {
      if (this.currentRow) {
        let index = this.model.columns.indexOf(this.currentRow)
        if (index >= 0)
          this.model.columns.splice(index,1)
      }
    },
    moveUpColumn: function () {
      if (this.currentRow) {
        let index = this.model.columns.indexOf(this.currentRow)
        if (index > 0)
          this.model.columns.splice(index-1, 1, ...this.model.columns.splice(index, 1, this.model.columns[index-1]));
          //[this.model.columns[index], this.model.columns[index-1]] = [this.model.columns[index-1], this.model.columns[index]];
      }
    },
    moveDownColumn: function () {
      if (this.currentRow) {
        let index = this.model.columns.indexOf(this.currentRow)
        if (index < this.model.columns.length-1)
          this.model.columns.splice(index + 1, 1, ...this.model.columns.splice(index, 1, this.model.columns[index + 1]));
        //[this.model.columns[index], this.model.columns[index-1]] = [this.model.columns[index-1], this.model.columns[index]];
      }
    },
    saveModel: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let para = Object.assign({}, this.model)
          para.columns.forEach((item, index) => {
            item.sortId = index;
          });
          this.$ajax({
            url: 'api/DataCollect/SaveModel',
            data: JSON.stringify(para),
            loadingName: 'addLoading',
            success: (response) => {
              this.$message({
                message: '保存成功',
                type: 'success',
                duration: 1000
              })
              this.getModel()
            }
          })
        }
      })
    },
  },
  mounted() {
    this.getModel()
  }
}
</script>